export default __webpack_public_path__ + "static/media/lucky-blue.c44019c6.png";